import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface trackerState {
    isTracking: boolean,
    trackingTimeInSec: number,
    trackingStartedAt: string,
    trackingTimeLogged: boolean,
    isMeetingTaskRunning: boolean,
    sessionExpire: boolean,
    refreshTokenTiming: string[],
}

export const initialState: trackerState = {
    isTracking: false,
    trackingTimeInSec: 0,
    trackingStartedAt: "",
    trackingTimeLogged: false,
    isMeetingTaskRunning: false,
    sessionExpire: false,
    refreshTokenTiming: [],
}

export const trackerSlice = createSlice({
    name: 'tracker',
    initialState,
    reducers: {

        setTrackingState: (state, action: PayloadAction<boolean>) => {
            state.isTracking = action.payload
        },

        setTrackingTimeState: (state, action: PayloadAction<number>) => {
            state.trackingTimeInSec = action.payload
        },

        setTrackingStartedAt: (state, action: PayloadAction<string>) => {
            state.trackingStartedAt = action.payload
        },

        setTrackingTimeLogged: (state, action: PayloadAction<boolean>) => {
            state.trackingTimeLogged = action.payload
        },

        setIsMeetingTaskRunning: (state, action: PayloadAction<boolean>) => {
            state.isMeetingTaskRunning = action.payload;
        },
        clearTrackingState: (state) => {
            state = structuredClone(initialState);
        },
        setSessionExpire: (state, action: PayloadAction<boolean>) => {
            state.sessionExpire = action.payload;
        },
        setRefreshTokenTiming: (state, action: PayloadAction<string[]>) => {
            state.refreshTokenTiming = action.payload;
        },
        clearTrackingSlice: (state,) => {
            state.isTracking = false;
            state.isMeetingTaskRunning = false;
            state.sessionExpire = false;
            state.trackingStartedAt = '';
            state.trackingTimeInSec = 0;
            state.trackingTimeLogged = false
        },

    }
});

export const {
    setTrackingState,
    setTrackingTimeState,
    setTrackingStartedAt,
    setTrackingTimeLogged,
    setIsMeetingTaskRunning,
    clearTrackingState,
    setSessionExpire,
    clearTrackingSlice,
    setRefreshTokenTiming
} = trackerSlice.actions;

export default trackerSlice.reducer;